import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function PartnerLoginPage() {
  const [form, setForm] = useState({ email: "", password: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.info("Partner portal coming soon. Please contact your representative.");
  };

  return (
    <div className="py-14 md:py-20 px-4 bg-partner min-h-screen flex items-center justify-center" data-testid="partner-login-page">
      <div className="max-w-sm w-full">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-7 h-7 text-amber-400" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-1" data-testid="partner-login-heading">Partner Login</h1>
          <p className="text-sm text-slate-400">Access your partner dashboard</p>
        </div>

        <Card className="border-slate-800 bg-[#111827]/60 backdrop-blur-sm">
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="partner-login-form">
              <div className="space-y-1.5">
                <Label className="text-slate-300">Email</Label>
                <Input
                  data-testid="partner-login-email"
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm(prev => ({ ...prev, email: e.target.value }))}
                  placeholder="partner@company.com"
                  className="bg-slate-800/50 border-slate-700 text-white placeholder:text-slate-600 focus-visible:ring-amber-500/50"
                />
              </div>
              <div className="space-y-1.5">
                <Label className="text-slate-300">Password</Label>
                <Input
                  data-testid="partner-login-password"
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm(prev => ({ ...prev, password: e.target.value }))}
                  placeholder="Enter password"
                  className="bg-slate-800/50 border-slate-700 text-white placeholder:text-slate-600 focus-visible:ring-amber-500/50"
                />
              </div>
              <Button
                type="submit"
                data-testid="partner-login-submit"
                className="w-full bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-[#0a0e1a] font-bold h-11 cta-gold"
              >
                Sign In
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
